import "./styles/index.less";
import * as lastComments from "../../blocks/last_comments/lastcomments";

export function init(type = null) {
    lastComments.init({
        commentsType: 'reviews',
        reviewType: type
    });
}


// WEBPACK FOOTER //
// ./modules/reviews/sidebar/index.js